module.exports = __webpack_public_path__ + "static/vuja-978b9ae079d4d70c6361f71df54d04b8.png";